import getConfigDetails  from '../services/config'

export const getConfig = () => {

    const partner = localStorage.getItem('partnerData') ? JSON.parse(localStorage.getItem('partnerData')) : {}

    const mainBaseUrl = getConfigDetails?.baseURL
    const baseUrl = partner?.api_config?.url ? partner?.api_config?.url : getConfigDetails?.baseURL
	return {
		getUserLoginUrl: `${baseUrl}oauth/access_token`,
		singupUrl: `${baseUrl}sign-up`,
		getPassListUrl: `${baseUrl}get-mapco-passes`,
		getEventListUrl: `${baseUrl}get-mapco-event-list`,
		downloadQrcodeRequestUrl: `${baseUrl}mapco-download-qrcode`,
		downloadPassQrcodeRequestUrl: `${baseUrl}download-passes`,
		// STORE EVENT LOG
		storeEventLog: `${baseUrl}addUserEvent`,
		// UPDATED USER PROFILE
		updateUserProfileUrl: `${baseUrl}diamond-update-profile`,
		// Get user profile
		getUserProfileUrl: `${baseUrl}diamond-get-user-by-id`,
		// Get user profile
		getUserProfileData: `${baseUrl}api`,
		// Reset Password
		postRestPassword: `${baseUrl}reset-are-password`,
		// GET PARTNER DETAILS BY SLUG
		getPartnerBySlug: `${mainBaseUrl}partner-details-by-slug`,
		// for the api before payment 
		saveBookingBeforePaymentUrl: `${baseUrl}mapco-booking-before-payment`,
		// GET SESSION DETAILS
		getSessionDetails: `${baseUrl}planet-payment-session-pci`,
		// after payment api
		saveBookingafterPaymentUrl: `${baseUrl}mapco-booking-after-payment`,
		// API TO UPDATE PROMOCODE USAGES
		getPromoCodeUsage: `${baseUrl}update_promocode_usage`,

		// forgot password 
		sendEmailResetPassword: `${baseUrl}user/reset-password/email`,

		// Passowrd Reset
		resetPassword: `${baseUrl}user/reset-password`,

		// nonce payment gate way api 
		noncePaymentGateway: `${baseUrl}event-booking-web`,

		// GET CARD LIST URL
		getCardDataUrl: `${baseUrl}get-card-profile`,

		// filtered event list url 
		getFilteredEventDataByDate: `${baseUrl}get-event-date-list`,
		getVehicleListUrl: `${baseUrl}get-vehicle-list`,
		getVehicleModelUrl: `${baseUrl}get-all-make-models`,

		getApplePassWalletDownload: `${baseUrl}genarate-pass-apple-wallet-pass`,
		getGooglePassWalletDownload: `${baseUrl}genarate-pass-google-wallet-pass`,

		getAppleReservationWalletDownload: `${baseUrl}genarate-reservation-apple-wallet-pass`,
		getGoogleReservationWalletDownload: `${baseUrl}genarate-reservation-google-wallet-pass`,
		singleEventUrl: `${getConfigDetails?.baseURL}event-detail/edit`,

	}
}

export const APICONFIG = new Proxy({}, {
    get(target, prop) {
        const cfg = getConfig()   // ✅ always fetch latest config
        return cfg[prop]          // ✅ return dynamic value
    }
})
